import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useState } from 'react';
import { useWeb3Onboard } from '../context.js';
import { useAppState } from './useAppState.js';
export var useConnectWallet = function useConnectWallet() {
  var web3Onboard = useWeb3Onboard();
  var connectWallet = web3Onboard.connectWallet,
    disconnectWallet = web3Onboard.disconnectWallet;
  var wallets = useAppState('wallets');
  var wallet = wallets[0] || null;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    connecting = _useState2[0],
    setConnecting = _useState2[1];
  var connect = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
      var walletState;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setConnecting(true);
            _context.next = 3;
            return connectWallet(options);
          case 3:
            walletState = _context.sent;
            setConnecting(false);
            return _context.abrupt("return", walletState);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  var disconnect = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
      var label, walletState;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            label = _ref2.label;
            setConnecting(true);
            _context2.next = 4;
            return disconnectWallet({
              label: label
            });
          case 4:
            walletState = _context2.sent;
            setConnecting(false);
            return _context2.abrupt("return", walletState);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  var updateBalances = web3Onboard.state.actions.updateBalances;
  var setWalletModules = web3Onboard.state.actions.setWalletModules;
  var setPrimaryWallet = web3Onboard.state.actions.setPrimaryWallet;
  return [{
    wallet: wallet,
    connecting: connecting
  }, connect, disconnect, updateBalances, setWalletModules, setPrimaryWallet];
};